<template>
  <div class="header d-flex justify-space-between align-center" :class="{ mobile: isMobile }">
    <div class="d-flex flex-row align-center" v-if="!isMobile">
      <img class="logo" src="@/assets/Uptick Network logo.svg" alt="" @click="openHome" />
      <div class="nav d-flex flex-row">
        <span @click="toHome">Home</span>
        <span @click="toPrice">Pricing</span>
        <div class="docment" @click.stop="toDevelopment()">Documentation</div>
        <div class="menuList" v-if="isShowMenu">
          <div class="listTitle" @click="toknowledge">Knowledge Base</div>
          <div class="listTitle" @click="toGuide">Developer Guide</div>
          <div class="listTitle"  @click="toHub">Web3 Application Developer Hub</div>

        </div>

      </div>



    </div>

    <div v-if="isMobile" style="width:100%" class="d-flex flex-row align-center justify-space-between">
      <img class="logo" src="@/assets/Uptick Network logo.svg" alt="" @click="openHome" />
      <v-icon class="mr-7" @click.stop="toggleDrawer" color="#ffffff">mdi-menu }</v-icon>


     
    </div>
    <div>

<div class="drawer" :class="{ open: isDrawerOpen }" v-if="isDrawerOpen">
  <ul>
    <li @click="toHome">Home</li>
    <li @click="toPrice">Pricing</li>
    <li @click="toDevelopment"> Documentation</li>
    <li @click="toCreate"> Create Project</li>

  
   
  </ul>
</div>
</div>


    <div class="userInfo d-flex flex-row">

      <div class="status d-flex flex-row align-center">
        <button class="create mr-3" @click="toCreate"  v-if="!isMobile">Create Project</button>
        <button class="signIn" @click="toLoginIn" v-if="!userInfo || userInfo.code == 10003"> <img class="user mr-2 " src="@/assets/icon_user.png"
            alt="" />Sign In</button>
        <div class="status" v-else>
          <!-- <div class="name d-flex align-center ml-3" v-if="userInfo.code == 10003" @click="toLoginIn">
            <img class="user mr-2 " src="@/assets/icon_user.png" alt="" />
            Sign In
          </div> -->
          <div class="Sign ml-3 d-flex flex-row" @click.stop="showList">
            <img class="user mr-2" src="@/assets/icon_user.png" alt="" />
            <div class="name">{{ userInfo.data?userInfo.data.name :'' }}</div>
            <v-icon class="ml-2 mt-n1" color="white" v-if="isShow">mdi-menu-up</v-icon>
            <v-icon class="ml-2 mt-n1" color="white" v-else>mdi-menu-down</v-icon>
            <div class="list" v-if="isShow">
              <div class="items">
                <div class="item" v-for="(item) in list" :key="item.id">
                  <div class="name" @click.stop="menuChange(item.route)">{{ item.name }}</div>
                </div>
              </div>

            </div>
          </div>

        </div>

      </div>
    </div>



  </div>
</template>

<script>
import { removeCookies } from "../utils/cookie";
import { loginOut, getMyInfo } from "../api/home";
export default {
  name: "Header",
  components: {},
  data: function () {
    return {
      isShowMenu:false,
      isDrawerOpen: false,
         status: 2,
      isShow: false,
      userInfo: {},
      list: [
        {
          name: 'My Profile',
          id: 0,
          route: 'user'

        },
        {
          name: 'Projects',
          id: 1,
          route: 'project'

        },
        {
          name: 'Statistics',
          id: 2,
          route: 'statistics'

        },
        {
          name: 'Orders',
          id: 4,
          route: 'orders'

        },
        // {
        //   name: 'Contact us',
        //   id: 5,
        //   route: 'contact'

        // },
       
        {
          name: 'Sign Out',
          id: 3,
          route: 'Home'

        },
      ]
    }

  },
  computed: {
    isMobile: function () {
      return this.$vuetify.breakpoint.mobile;
    },
  },
  async mounted() {
    console.log("hEader");
    window.addEventListener("click", this.clickOther);
    window.eventBus.$on('disconnect', this.disConnect);
    let user = await getMyInfo()
    this.userInfo = user.data

  },
  methods: {
    clickOther(){
      this.isShowMenu =false
      this.isShow = false
    },
     toknowledge(){
      window.open('https://upticknft.gitbook.io/uptick-network-documentation','_blank')
      this.isShowMenu =false
    },
    toGuide(){
      window.open('https://upticknft.gitbook.io/uptick-developer-documentation','_blank')
      this.isShowMenu =false
    },
    toHub(){
      window.open('https://upticknft.gitbook.io/web3_application_developer_hub','_blank')
      this.isShowMenu =false
    },

    
    toggleDrawer() {
      this.isDrawerOpen = !this.isDrawerOpen;
    },
    toCreate() {
      console.log('wxl ---- !this.userInfo', this.userInfo);


      if (!this.userInfo.success) {
        this.$router.push({ name: 'Login' })
      } else {
        this.$router.push({ name: 'CreateProject' })
      }

      this.isDrawerOpen = false
      
    },
    toHome() {
      this.$router.push({ name: 'Home' })
      this.isDrawerOpen = false
    },

    toPrice() {
    //  let isLogin =  localStorage.getItem('Authorization')
    //  if(isLogin){
    //   this.$router.push({ name: 'Pricing' })
    //  }else{
    //   this.$router.push({ name: 'Login' })

    //  }

     this.$router.push({ name: 'Pricing' })
     
      this.isDrawerOpen = false

    },


    moused() {
      console.log('wxl ---- moused');
      this.isShowMenu = true


    },
    toShowList() {
      this.isShowMenu = !this.isShowMenu

    },
    leave() {
      console.log('wxl --- leave');
      this.isShowMenu = false
    },
    toLoginIn() {
      console.log('wxl ---- Login');

      this.$router.push({ name: 'Login' })
    },
    openHome() {
      //https://www.uptick.network/
      this.$router.push({ name: "Home" })
    },
    toDevelopment(){
      window.open('https://docs.services.uptick.network/','_blank')
    },
    async disConnect() {
      let user = await getMyInfo()
      this.userInfo = user.data
    },
    toSignIn() {
      this.$router.push({ name: "Home" })
    },
    showList() {
      this.isShow = !this.isShow
    },
    async menuChange(route) {
      
      console.log('wxl ---- menuChange',this.isShow);
      
      if (route == 'Home') {
        await loginOut();
        this.isShow = false
        //  removeCookies('userPsswd')
        localStorage.removeItem('Authorization')
        this.$router.push({ name: "Login" })
      } else {
        this.isShow = false
        this.$router.push({ name: "myInfo", query: { "source": route } })
      }
      console.log('wxl ---  this.isShow', this.isShow);
      
 
    }
  }
};
</script>

<style lang="scss" scoped>
.header {
  margin: 20px 40px 0;
  padding: 0;
  width: calc(100% - 180px);

  .drawer {

    width: 100%;
    z-index: 100;
  position: absolute;
  top: 70px;
  right: -250px; 

  height:100%;
  background: #333;
  color: #fff;
  transition: right 0.3s; /* 添加过渡效果 */
  ul {
    padding:30px 0 0 30px;
    li{
      font-family: AvenirNext-Medium;
    font-size: 20px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 30px;
    color: #ffffff;
    text-align: left
    }
  }
}

.drawer.open {
  right: 0; 
}

ul {
  list-style: none;
  padding: 0;
}

li {
  padding: 10px;
  cursor: pointer;
}

  .name {
    cursor: pointer;
    font-family: AvenirNext-Medium;
    font-size: 15px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 15px;
    letter-spacing: 0px;
    color: #ffffff;
  }

  .logo {

    width: 110px;
    height: 46px;
    margin-right: 67px;
  }

  .nav {
    cursor: pointer;
    position: relative;

    span {
      font-family: AvenirNext-Medium;
      font-size: 15px;
      font-weight: normal;
      font-stretch: normal;
      line-height: 20px;
      letter-spacing: 0px;
      color: #ffffff;
      margin-right: 20px;
    }

    .docment {
      position: relative;
      font-family: AvenirNext-Medium;
      font-size: 15px;
      font-weight: normal;
      font-stretch: normal;
      line-height: 20px;
      letter-spacing: 0px;
      color: #ffffff;
      margin-right: 20px;

    }

    .menuList {
      padding: 27px 20px;
      z-index: 100;
      position: absolute;
      left: 120px;
      top: 30px;
      width: 285px;
      height: 160px;
      background-color: #000000;
      border-radius: 10px;
      border: solid 1px #ff704a;

      .listTitle {
        font-family: AvenirNext-Medium;
        font-size: 15px;
        font-weight: normal;
        font-stretch: normal;
        line-height: 35px;
        letter-spacing: 0px;
        color: #ffffff;
      }
    }
  }

  .userInfo {
    .user {
      cursor: pointer;
      width: 15px;
      height: 15px;
    }
  }

  .status {
    .create {
      width: 156px;
      height: 41px;
      background-image: linear-gradient(128deg,
          #b734ee 0%,
          #ff704a 100%);
      border-radius: 5px;
      font-family: AvenirNext-Medium;
      font-size: 15px;
      font-weight: normal;
      font-stretch: normal;
      line-height: 20px;
      letter-spacing: 0px;
      color: #ffffff;
    }

    .signIn {
      width: 131px;
      height: 41px;
      background-color: #a443f6;
      border-radius: 5px;
      font-family: AvenirNext-Medium;
      font-size: 15px;
      font-weight: normal;
      font-stretch: normal;
      line-height: 20px;
      letter-spacing: 0px;
      color: #ffffff;
    }

    .Sign {
      position: relative;

      .list {
        position: absolute;
        top: 30px;
        right: 7px;
        width: 119px;
        height: 250px;
	background-color: #000000;
	border-radius: 10px;
	border: solid 1px #ff704a;
        z-index: 10;

        .items {
          width: 100%;

          margin: 20px 17px;

          .item {

            .name {
              font-family: AvenirNext-Medium;
              font-size: 15px;
              font-weight: normal;
              font-stretch: normal;
              line-height: 40px;
              letter-spacing: 0px;
              color: #ffffff;

            }
          }
        }


      }

    }

  }

  &.mobile {
    width: calc(100% - 80px);
    .signIn{
      width: 120px;
    }
   
  }
}
</style>
